export default function AppEntry() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          APP下载<i className="ri-download-2-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">随时随地 · 吃瓜不停</p>

        <div className="mt-8 max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
              <div className="w-40 h-40 md:w-48 md:h-48 flex-shrink-0 rounded-3xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20icon%20design%20with%20bold%20red%20crimson%20gradient%20background%20and%20abstract%20news%20eye%20symbol%2C%20minimalist%20flat%20design%2C%20clean%20geometric%20shapes%2C%20dark%20mode%20aesthetic%2C%20app%20store%20quality%20render&width=400&height=400&seq=app-icon-91hl&orientation=squarish"
                  alt="91黑料APP图标"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-xl font-heading font-bold text-foreground-900">91黑料 官方APP</h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  下载91黑料官方APP，享受更流畅的吃瓜体验。支持实时推送通知，重大爆料不再错过；离线缓存功能让你随时随地刷最新内容；暗黑模式保护夜间阅读视力。
                </p>
                <div className="mt-4 flex flex-wrap items-center justify-center md:justify-start gap-3">
                  <div className="flex items-center gap-1.5 text-xs text-foreground-500 bg-background-200/70 px-3 py-1.5 rounded-full">
                    <i className="ri-android-line text-sm"></i>
                    <span>Android</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-foreground-500 bg-background-200/70 px-3 py-1.5 rounded-full">
                    <i className="ri-apple-line text-sm"></i>
                    <span>iOS</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-foreground-500 bg-background-200/70 px-3 py-1.5 rounded-full">
                    <span>v3.8.2</span>
                  </div>
                </div>
                <div className="mt-5 flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
                  <a
                    href="#"
                    className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-download-line"></i>
                    安卓下载
                  </a>
                  <a
                    href="#"
                    className="whitespace-nowrap inline-flex items-center gap-2 border border-foreground-300 text-foreground-700 px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-background-50 transition-colors cursor-pointer"
                  >
                    <i className="ri-apple-line"></i>
                    App Store
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}